<template>
  <div class="data-search">
    <div class="data-search__before-search">
      <div class="data-search__before-search__time-class">
        <div class="data-search__before-search__time-class-item" :class="{'active': timeModel == 'year'}">年資料 => 
          <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'trend'}" @click="changechartClass('year','trend')">走勢</span>
          <!-- <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'histogram'}" @click="changechartClass('year','histogram')">對比</span> -->
        </div>
        <div class="data-search__before-search__time-class-item" :class="{'active': timeModel == 'month'}">月資料 => 
          <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'trend'}" @click="changechartClass('month','trend')">走勢</span>
          <!-- <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'histogram'}" @click="changechartClass('month','histogram')">對比</span> -->
        </div>
        <div class="data-search__before-search__time-class-item" :class="{'active': timeModel == 'day'}">日資料 => 
          <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'trend'}" @click="changechartClass('day','trend')">走勢</span>
          <!-- <span class="data-search__before-search__time-class-item-list" :class="{'list-active': chartModel == 'histogram'}" @click="changechartClass('day','histogram')">對比</span> -->
        </div>
      </div>
      <div class="data-search__before-search__list-class">
        <div class="data-search__before-search__list-class__item time" v-if="!(chartModel == 'trend' && timeModel == 'year')">
          <div class="data-search__before-search__list-class__item-group">
            <div class="data-search__before-search__list-class__item-group-label" v-if="chartModel == 'histogram'">時間 A：</div>
            <template v-if="
              chartModel == 'trend' ? timeModel != 'year' : true
            ">
              <span class="data-search__before-search__list-class__item-label">年份</span>
              <select v-model="yearModel_A" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in yearRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
            <template v-if="
              chartModel == 'trend' ? (timeModel != 'year' && timeModel != 'month') : timeModel != 'year'
            ">
              <span class="data-search__before-search__list-class__item-label">月份</span>
              <select v-model="monthModel_A" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in monthRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
            <template  v-if="
              chartModel == 'trend' ? false : (timeModel != 'year' && timeModel != 'month')
            ">
              <span class="data-search__before-search__list-class__item-label">日期</span>
              <select v-model="dayModel_A" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in dayRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
          </div>
          <div class="data-search__before-search__list-class__item-group" v-if="chartModel == 'histogram'">
            <div class="data-search__before-search__list-class__item-group-label">時間 B：</div>
            <template>
              <span class="data-search__before-search__list-class__item-label">年份</span>
              <select v-model="yearModel_B" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in yearRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
            <template v-if="timeModel != 'year'">
              <span class="data-search__before-search__list-class__item-label">月份</span>
              <select v-model="monthModel_B" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in monthRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
            <template v-if="timeModel != 'year' && timeModel != 'month'">
              <span class="data-search__before-search__list-class__item-label">日期</span>
              <select v-model="dayModel_B" class="data-search__before-search__list-class__item-select">
                <template v-for="(item, index) in dayRange">
                  <option :value="item" :key="index">{{item}}</option>
                </template>
              </select>
            </template>
          </div>
        </div>
        <div class="data-search__before-search__list-class__item list">
          <span class="data-search__before-search__list-class__item-label">種類</span>
          <select v-model="dataModel" class="data-search__before-search__list-class__item-select">
            <template v-for="(item, index) in dataClass">
              <option :value="item.value" :key="index">{{item.key}}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="data-search__before-search__search">
        <button type="button" class="data-search__before-search__search-button" @click="getSearchList()">顯示</button>
      </div>
    </div>
    <div class="data-search__after-search">
      <svg class="data-search__after-search__svg"></svg>
    </div>
  </div>
</template>
<script>
import * as d3 from 'd3'
export default {
  name: "dataSearch",
  data(){
    let today = new Date();
    return{
      searchList: null,
      timeModel: "year",
      yearRange: [],
      yearModel_A: today.getFullYear(),
      yearModel_B: today.getFullYear(),
      monthRange: [],
      monthModel_A: today.getMonth() + 1,
      monthModel_B: today.getMonth() + 1,
      dayRange: [],
      dayModel_A: today.getDate(),
      dayModel_B: today.getDate(),
      dataModel: "revenue",
      chartModel: "trend",
      dataClass: [
        {key: "收入", value: "revenue"},
        {key: "進出量", value: "count"}
      ],
      chartClass: [
        {key: "柱狀圖", value: "Histogram"},
        {key: "趨勢圖", value: "trend"},
        {key: "清單", value: "list"}
      ],
      testYearData: [],
      testMonthData: {},
      testDaysData: {}
    }
  },
  methods: {
    changechartClass(time, chart){
      this.timeModel = time;
      this.chartModel = chart;
    },
    async getSearchList(){
      let submitData = null;
      if(this.chartModel == 'trend'){
        if(this.timeModel == 'year'){
          submitData = {
            time: String(this.yearModel_A),
            data: this.dataModel
          }
        }else if(this.timeModel == 'month'){
          submitData = {
            time: `${this.yearModel_A}${this.monthModel_A < 10 ? '0' + this.monthModel_A : String(this.monthModel_A)}`,
            data: this.dataModel
          }
        }else{
          submitData = {
            time: `${this.yearModel_A}${this.monthModel_A < 10 ? '0' + this.monthModel_A : String(this.monthModel_A)}${this.dayModel_A < 10 ? '0' + this.dayModel_A : String(this.dayModel_A)}`,
            data: this.dataModel
          }
        }
      }else if(this.chartModel == 'histogram'){
        if(this.timeModel == 'year'){
          submitData = {
            time_A: String(this.yearModel_A),
            time_B: String(this.yearModel_B),
            data: this.dataModel
          }
        }else if(this.timeModel == 'month'){
          submitData = {
            time_A: `${this.yearModel_A}${this.monthModel_A < 10 ? '0' + this.monthModel_A : String(this.monthModel_A)}`,
            time_B: `${this.yearModel_B}${this.monthModel_B < 10 ? '0' + this.monthModel_B : String(this.monthModel_B)}`,
            data: this.dataModel
          }
        }else{
          submitData = {
            time_A: `${this.yearModel_A}${this.monthModel_A < 10 ? '0' + this.monthModel_A : String(this.monthModel_A)}${this.dayModel_A < 10 ? '0' + this.dayModel_A : String(this.dayModel_A)}`,
            time_B: `${this.yearModel_B}${this.monthModel_B < 10 ? '0' + this.monthModel_B : String(this.monthModel_B)}${this.dayModel_A < 10 ? '0' + this.dayModel_B : String(this.dayModel_B)}`,
            data: this.dataModel
          }
        }
      }
      let res = await this.returnSearchList(submitData);
      this.drawTrend(res);
    },
    drawTrend(resArray){
      let beClearElement = document.querySelector(".data-search__after-search__svg");
      let beClearNodes = beClearElement.lastElementChild;
      while(beClearNodes){
        beClearElement.removeChild(beClearNodes);
        beClearNodes = beClearElement.lastElementChild;
      }
      const resData = resArray;
      let margin = {top: 20, right: 20, bottom: 50, left: 70};
      let width = 300 - margin.left - margin.right;
      let height = 200 - margin.top - margin.bottom;
      // set the ranges
      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().range([height, 0]);

      // define the line
      var valueline = d3.line()
          .x(function(d) { return x(d.date); })
          .y(function(d) { return y(d.count); })
          .curve(d3.curveBasis);

      var svg = d3.select(".data-search__after-search__svg")
          .attr("preserveAspectRatio", "xMinYMin meet")
          .attr("viewBox","0,0,"+(width + margin.left + margin.right)+","+(height + margin.top + margin.bottom))
          .append("g")
          .attr("transform","translate(" + margin.left + "," + margin.top + ")");

      x.domain(d3.extent(resData, function(d) { return d.date; }));
      y.domain([d3.min(resData, function(d){return d.count * 0.97}), d3.max(resData, function(d) { return d.count * 1.02; })]);

      // Add the valueline path.
      svg.append("path")
          .data([resData])
          .attr("class", "Polyline")
          .attr("d", valueline)
          .attr("fill","none")
          .attr("stroke", "steelBlue")
          .attr("stroke-width", "2px");
      
      // Add the x Axis
      if(this.timeModel == 'year'){
        svg.append("g")
          .attr("transform", "translate(0," + height + ")")
          .call(
            d3.axisBottom(x).tickFormat(d3.timeFormat("%y"))
            .ticks(resData.length)
          )
          .selectAll("text")
          .style("text-anchor", "end")
          .attr("dx", "-.4em")
          .attr("dy", ".15em")
          .attr("font-size","8px");
      }else if(this.timeModel == 'month'){
        svg.append("g")
          .attr("transform", "translate(0," + height + ")")
          .call(
            d3.axisBottom(x).tickFormat(d3.timeFormat("%m"))
            .ticks(resData.length)
          )
          .selectAll("text")
          .style("text-anchor", "end")
          .attr("dx", "-.4em")
          .attr("dy", ".15em")
          .attr("font-size","8px");
      }else if(this.timeModel == 'day'){
        svg.append("g")
          .attr("transform", "translate(0," + height + ")")
          .call(
            d3.axisBottom(x).tickFormat(d3.timeFormat("%d"))
            .ticks(resData.length/2)
          )
          .selectAll("text")
          .style("text-anchor", "end")
          .attr("dx", "-.4em")
          .attr("dy", ".15em")
          .attr("font-size","8px");
      }
      
      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y).ticks(5)).selectAll("text").attr("font-size","8px");
    },
    drawHistogram(resArray){

    },
    returnSearchList(){
      if(this.chartModel == 'trend'){
        if(this.timeModel == 'year'){
          return this.testYearData;
        }else if(this.timeModel == 'month'){
          return this.testMonthData[this.yearModel_A];
        }else if(this.timeModel == 'day'){
          return this.testDaysData[this.yearModel_A][this.monthModel_A];
        }
      }
    }
  },
  beforeMount(){
    for(let y = 2015; y < 2035; y++){
      this.yearRange.push(y);
    }
    for(let m = 1; m < 13; m++){
      this.monthRange.push(m);
    }
    let thisMonthDays = new Date(this.yearModel_A, this.monthModel_A, 0).getDate();
    for(let d = 1; d < thisMonthDays + 1; d++){
      this.dayRange.push(d);
    }
    let testDate = null;
    let randomCount = null;
    for(let ty = 2019; ty < 2022; ty++){
      let yearRevenue = null;
      let yearCountt = null;
      this.testMonthData[ty] = [];
      this.testDaysData[ty] = {};
      for(let tm = 0; tm < 12; tm++){
        let monthRevenue = null;
        let monthCount = null;
        this.testDaysData[ty][tm] = [];
        testDate = new Date(ty, tm, 0).getDate();
        for(let td = 1; td < testDate + 1; td++){
          randomCount = parseInt(Math.random()*40+1);
          this.testDaysData[ty][tm].push({
            date: new Date(ty,tm,td),
            revenue: randomCount*50,
            count: randomCount
          })
          monthRevenue += randomCount*50;
          monthCount += randomCount;
        }
        this.testMonthData[ty].push({
          date: new Date(ty,tm,1),
          revenue: monthRevenue,
          count: monthCount,
        })
        yearRevenue += monthRevenue;
        yearCountt += monthCount;
      }
      this.testYearData.push({
        date: new Date(ty,1,1),
        revenue: yearRevenue,
        count: yearCountt
      })
    }
  }
}
</script>